import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const headerV2Styles = (theme: Theme) => ({
	root: {
		position: 'sticky',
		left: 0,
		right: 0,
		zIndex: 1000,
		width: '100%',

		display: 'flex',
		flexDirection: 'column',

		borderBottom: `2px solid ${Colors['120E0D']}`,
		backgroundColor: '#fff',
		overflow: 'auto',
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		py: 2,
		px: 4,
		gap: { xs: '20px', md: '30px', lg: '40px' },
	},
});

export const headerV3Styles = (theme: Theme) => ({
	root: {
		position: 'sticky',
		left: 0,
		right: 0,
		zIndex: 1000,
		width: '100%',
		display: { xs: 'none', md: 'block' },
		borderBottom: `2px solid ${Colors['120E0D']}`,
	},
	row: {
		backgroundColor: '#11141299',
		backdropFilter: 'blur(10px)',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		py: '18px',
		px: { xs: '24px', md: '16px', lg: '54px' },
		gap: { xs: '12px', lg: '40px' },
		height: { xs: '60px', md: '70px' },
	},
});
